import { put, call, takeLatest } from "redux-saga/effects";
import { JOIN_GAME_REQUEST } from "../actionTypes/type";
import { actionSuccess, actionError } from "../actions/joinAction";
import { postApiCall } from "../../services/PostApiCall";
import { JOIN_URL } from "../../services/apiUrl";

export function* joinSaga(action) {
  try {
    const response = yield call(postApiCall, action.params, JOIN_URL);
    yield put(actionSuccess(response.data.data));
    action.onSuccess();
  } catch (error) {
    yield put(actionError(error));
    action.onError(error);
  }
}

export function* watchJoinSaga() {
  yield takeLatest(JOIN_GAME_REQUEST, joinSaga);
}
